import { memo } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Check, CheckCheck, Clock3 } from "lucide-react";
import "../../global.css";
import { formatChatTimestamp } from "Components/Utilities/DateUtils";



function StatusIcon({ status }) {
  if (!status) return null;
  if (status === "queued") return <Clock3 className="h-3.5 w-3.5" aria-hidden />;
  if (status === "sent") return <Check className="h-3.5 w-3.5" aria-hidden />;
  const isRead = status === "read";
  return (
    <CheckCheck
      className={`h-3.5 w-3.5 ${isRead ? "text-[#53bdeb]" : ""}`}
      aria-hidden
    />
  );
}

function MessageBubble({ message, onProfileClick, isGroup = false }) {
  const { content, timeStamp, isMine, status, avtar, name } = message;

  // console.log("Iam Time", timeStamp)

  const time = formatChatTimestamp(timeStamp);

  // ✅ Now your own messages → RIGHT, others → LEFT
  const alignment = isMine ? "justify-end" : "justify-start";

  // ✅ Bubble colors
  const baseBubble = isMine
    ? "bg-[#E6EEFF] text-[#e9edef]" // your message (greenish)
    : "bg-white text-[#111b21]";   // others’ message (white)

  const statusColor = "text-[#8696a0]";

  return (
    <div className={`flex items-end gap-2 ${alignment}`}>
      {/* Avatar for others (left side) */}
      {!isMine && (
        <button
          type="button"
          onClick={onProfileClick}
          className="shrink-0 rounded-full ring-2 ring-[#0b8457]/60 transition hover:ring-[#25d366]"
          aria-label={`View ${name} profile`}
        >
          <Avatar className="h-7 w-7">
            <AvatarImage src={avtar} alt={name} referrerPolicy="no-referrer" />
            <AvatarFallback>{name?.slice(0, 2)?.toUpperCase()}</AvatarFallback>
          </Avatar>
        </button>
      )}

      <div className="max-w-[72%] space-y-1 text-sm text-left">
        {/* Group sender name */}
        {!isMine && isGroup && (
          <button
            type="button"
            onClick={onProfileClick}
            className="text-[11px] font-semibold uppercase tracking-wide text-[#53bdeb]"
          >
            {name}
          </button>
        )}

        {/* Message bubble */}
        <div
          className={`relative flex flex-col min-w-[150px] max-w-[100%] rounded-2xl px-3 py-2 shadow-sm ${baseBubble}`}
        >
          <div className="whitespace-pre-wrap break-words leading-relaxed text-sm">
            {content}
          </div>
          <div className={`mt-1 flex items-center justify-end gap-1 text-[10px] ${statusColor}`}>
            <span>{time}</span>
            {isMine && <StatusIcon status={status} />}
          </div>
        </div>
      </div>

      {/* Avatar for your messages (right side) */}
      {isMine && (
        <button
          type="button"
          onClick={onProfileClick}
          className="shrink-0 rounded-full ring-2 ring-[#0b8457]/60 transition hover:ring-[#25d366]"
          aria-label={`View ${name} profile`}
        >
          <Avatar className="h-7 w-7">
            <AvatarImage src={avtar} alt={name} referrerPolicy="no-referrer" />
            <AvatarFallback>{name?.slice(0, 2)?.toUpperCase()}</AvatarFallback>
          </Avatar>
        </button>
      )}
    </div>
  );
}

export default memo(MessageBubble);
